import trackClevertapEvents from "@/utils/trackClevertapEvents";

export default class cleverTapAndMixPanelEvents {
  static track(evntName, eventObj = {}) {
    trackClevertapEvents.eventPush(evntName, eventObj);
  }
}
